import React from 'react';
import classNames from 'classnames';
import Link from '../ui/link/Link';
import PrenavMenu from '../ui/prenav-menu/PrenavMenu';
import styles from './prenav-link.scss';

const PrenavLink = props => (
  <div
    className={styles.headerLinksContainer}
    data-testid="prenav-redesign-container"
  >
    <Link
      {...props}
      itemClassName={styles.headerLinkItem}
      anchorClassName={classNames(styles.headerLink, {
        [styles.headerLink__bp]: props.isBrandPromiseActive,
        [styles.headerLink__prenav]: props.isNewPreNavActive,
      })}
    />
    {props.isNewPreNavActive && props.menuLinks.length > 0 && (
      <PrenavMenu {...props} itemClassName={styles.prenavLinkMenuBox} />
    )}
  </div>
);

export default PrenavLink;
